import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.loading.fullscreen');
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-component-loading-fullscreen',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.loading.fullscreen/view.scss */
:host {
  display: contents;
}

.fullscreen-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  z-index: 80;
  background: color-mix(in srgb, var(--screen-bg, #12121c) 88%, transparent);
  backdrop-filter: blur(10px);
  color: var(--text, #e8e8f0);
}

.fullscreen-loader-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: min(260px, 100% - 48px);
  gap: 10px;
  text-align: center;
}

.fullscreen-loader-message {
  color: var(--text, #e8e8f0);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.35;
}

.fullscreen-loader-detail {
  min-height: 18px;
  color: var(--text-muted, var(--muted, rgba(232, 232, 240, 0.68)));
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.fullscreen-loader-bar {
  position: relative;
  width: 148px;
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--line, rgba(255, 255, 255, 0.08));
}

.fullscreen-loader-bar span {
  position: absolute;
  inset: 0 auto 0 0;
  width: 44%;
  border-radius: inherit;
  background: var(--primary, #a0a8d0);
  animation: fullscreen-loader-slide 1.1s ease-in-out infinite;
}

@keyframes fullscreen-loader-slide {
  0% {
    transform: translateX(-105%);
  }
  100% {
    transform: translateX(230%);
  }
}`],
})
export class ComponentLoadingFullscreenComponent {
    @Input() public message: string = '초기 데이터를 불러오는 중';
    @Input() public detail: string = '';
}

export default ComponentLoadingFullscreenComponent;